import React from 'react';

import { Container, Inner, ColLeft, ColRight } from './styles';

import ArrowDown from '~/components/ArrowDown';

export default function Intro() {
  return (
    <Container id="intro">
      <Inner>
        <ColLeft>
          <h3>
            <span>Campanha 3% que importam</span>
          </h3>
          <p className="highlight">Transforme parte do seu imposto de renda devido em impacto social.</p>	  	  
          <p>
            Você sabia que isso é possível? E mais: você ainda pode escolher um 
            projeto social da PUC-SP para apoiar!{' '}
            <b>Incentive nossos projetos.</b> É muito simples.
          </p>
        </ColLeft>
	  <ColRight>
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/VUbwkzk7QR4?si=22itFNEDgmKRdO0Q"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Video"
          ></iframe>
        </ColRight>
        <ArrowDown toElement="conheca" className="ArrowDown" />
      </Inner>
    </Container>
  );
}
